var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    [
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _c("b-table", {
            attrs: {
              id: "monthly-budget-detail-list",
              items: _vm.monthlyBudgetDetails,
              fields: _vm.fields,
              bordered: "",
              responsive: "",
              "current-page": _vm.currentPage,
              "per-page": 10
            },
            scopedSlots: _vm._u([
              {
                key: "head()",
                fn: function(data) {
                  return [
                    _vm._v(
                      "\n          " + _vm._s(_vm.$t(data.label)) + "\n        "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("b-pagination", {
            attrs: {
              "total-rows": _vm.monthlyBudgetDetails
                ? _vm.monthlyBudgetDetails.length
                : 0,
              "per-page": 10,
              "aria-controls": "monthly-budget-detail-list"
            },
            model: {
              value: _vm.currentPage,
              callback: function($$v) {
                _vm.currentPage = $$v
              },
              expression: "currentPage"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-73199964", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73199964","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/BudgetMaster/MonthlyBudgetDetails.vue
// module id = null
// module chunks = 